<tax-page-header
  [titleText]="componentTitle"
  [showBackButton]="true"
  [dropdownItems]="dropdownItems"
>
  <div class="layout-2-column">
    <div class="layout-left">
      <tax-cto-info [contract]="contract"></tax-cto-info>
    </div>
    <div class="layout-right">
      <!--TODO: fix $any-->
      <tax-cto-status
        [status]="$any(contract?.status)"
        [createdAt]="$any(contract?.createdAt)"
        [updatedAt]="$any(contract?.updatedAt)"
        [endsAt]="$any(contract?.endsAt)"
      ></tax-cto-status>
    </div>
  </div>
</tax-page-header>
